import { render, staticRenderFns } from "./bWflow.vue?vue&type=template&id=6ce1dcb1&"
import script from "./bWflow.vue?vue&type=script&lang=js&"
export * from "./bWflow.vue?vue&type=script&lang=js&"
import style0 from "./bWflow.vue?vue&type=style&index=0&id=6ce1dcb1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports